import { React } from '../../libraries'

const Backdrop = () => {
    return (
        <div className="backdrop w-full h-full fixed top-0 left-0 z-30 bg-black opacity-50"></div>
    )
}

export default Backdrop